/**
 * Common context menu generation methods used when building menu navigation
 * referenced server side in com.foretees.api.records.vueApp.enums.ContextMenuGen
 */

export default {
  reservations (vue) {
    return [
      {title: 'Add New Reservation', icon: 'mdi-plus', action: () => {vue.$router.push({query: {...vue.$route.query, ocrId: ''}})}}
    ]
  },
  events (vue) {
    return vue.$ftAccess.manageEvents ? [{title: 'Add New Event', icon: 'mdi-plus', action: () => {vue.$router.push({query: {...vue.$route.query, quickEventId: ''}})}}] : []
  },
}
